export default __webpack_public_path__ + "static/media/francheville16.a03d7b74.jpg";